import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./components/home-page/home-page.module").then(m => m.HomePageModule)
  },
  {
    path: "offers",
    loadChildren: () => import("./components/home-page/home-page.module").then(m => m.HomePageModule)
  },
  {
    path: "home",
    redirectTo: ''
  },
  {
    path:'offer-details',
    loadChildren: ()=> import("./components/offer-details/offer-details.module").then(m=>m.OfferDetailsModule)
  },
  {
    path:'offers/offer-details/:merchantId',
    loadChildren: ()=> import("./components/offer-details/offer-details.module").then(m=>m.OfferDetailsModule)
  },
  {
    path:'offers/offer-details/:merchantId/:categoryType',
    loadChildren: ()=> import("./components/offer-details/offer-details.module").then(m=>m.OfferDetailsModule)
  },
  {
    path:'offers/offer-details/:merchantId/:categoryType/:merhcantName',
    loadChildren: ()=> import("./components/offer-details/offer-details.module").then(m=>m.OfferDetailsModule)
  },
  {
    path:'offers/offer-details/:merchantId/:categoryType/:merhcantName',
    loadChildren: ()=> import("./components/offer-details/offer-details.module").then(m=>m.OfferDetailsModule)
  },
  {
    path: 'contextual',
    loadChildren: () => import("./modules/contextual/contextual.module").then(m => m.ContextualModule)
  },
  {
    path: 'gift-confirm/:booking_id',
    loadChildren: () => import("./modules/booking-confirmed/booking-confirmed.module").then(m => m.BookingConfirmedModule)
  },
  {
    path:'offers-list',
    loadChildren: () => import("./components/offers-list/offers-list.module").then(m => m.OffersListModule)
  },
  {
    path: 'savings-history',
    loadChildren: () => import("./components/redemption/redemption.module").then(m => m.RedemptionModule)
  },
  {
    path: 'info',
    loadChildren: () => import("./components/info/info.module").then(m => m.InfoModule)
  },
  {
    path: 'sso_login',
    loadChildren: () => import("./modules/loginSso/loginSso.module").then(m => m.LoginSsoModule)
  },
  {
    path: "exclusive-rewards",
    loadChildren: () => import("./components/home-page/home-page.module").then(m => m.HomePageModule)
  },
];
if(window && window.innerWidth < 768){
  routes.push(
    {
      path: "offers/:category_code",
      loadChildren: () => import("./components/offers-list/offers-list.module").then(m => m.OffersListModule)
    },
    {
      path: "offers/:category_code/:sub_cat_code",
      loadChildren: () => import("./components/offers-list/offers-list.module").then(m => m.OffersListModule)
    },
  );
} else {
  routes.push({
    path: "offers/:category_code",
    loadChildren: () => import("./components/home-page/home-page.module").then(m => m.HomePageModule)
  },
  {
    path: "offers/:category_code/:sub_cat_code",
    loadChildren: () => import("./components/home-page/home-page.module").then(m => m.HomePageModule)
  });
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
